import React from 'react'
import Index from 'components/checkout/index'

export default function Checkout() {
    return (
        <Index />
    )
}